// Check if string is url
export const getValidUrl = (url = "") => {
    var pattern = /^((http|https|ftp):\/\/)/;

    if (pattern.test(url)) {
        return true;
    } else {
        return false;
    }
};